/* ============================================================
   PawlyBuddy — Main JS v2.1 (Savings now includes real cart-level
   discounts like Buy 2/Buy 3 tiers, not just compare_at_price)
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {

  /* ── Mobile Menu ── */
  const hamburger = document.querySelector('.pb-hamburger');
  const mobileMenu = document.querySelector('.pb-mobile-menu');
  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', function (e) {
      e.stopPropagation();
      const open = mobileMenu.classList.toggle('open');
      hamburger.setAttribute('aria-expanded', open);
    });
    document.addEventListener('click', function (e) {
      if (!hamburger.contains(e.target) && !mobileMenu.contains(e.target)) {
        mobileMenu.classList.remove('open');
        hamburger.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* ── Product Quantity ── */
  document.querySelectorAll('.pb-qty').forEach(function (wrap) {
    const minus = wrap.querySelector('.pb-qty-minus');
    const plus  = wrap.querySelector('.pb-qty-plus');
    const input = wrap.querySelector('.pb-qty-val');
    if (!minus || !plus || !input) return;
    minus.addEventListener('click', function () {
      const v = parseInt(input.value, 10);
      if (v > 1) input.value = v - 1;
      input.dispatchEvent(new Event('change'));
    });
    plus.addEventListener('click', function () {
      const v = parseInt(input.value, 10);
      input.value = v + 1;
      input.dispatchEvent(new Event('change'));
    });
    input.addEventListener('change', function () {
      if (parseInt(input.value, 10) < 1 || isNaN(parseInt(input.value, 10))) input.value = 1;
    });
  });

  /* ── Product Tabs ── */
  document.querySelectorAll('.pb-prod-tabs').forEach(function (tabBar) {
    const tabs = tabBar.querySelectorAll('.pb-prod-tab');
    const section = tabBar.closest('.pb-product-page') || document;
    const panels = section.querySelectorAll('.pb-tab-panel');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(t => { t.classList.remove('active'); t.setAttribute('aria-selected','false'); });
        panels.forEach(p => p.classList.remove('active'));
        tab.classList.add('active');
        tab.setAttribute('aria-selected','true');
        const target = document.getElementById(tab.dataset.tab);
        if (target) target.classList.add('active');
      });
    });
  });

  /* ══════════════════════════════════════════
     CART DRAWER
  ══════════════════════════════════════════ */
  const cartDrawer  = document.getElementById('pb-cart-drawer');
  const cartOverlay = document.getElementById('pb-cart-overlay');
  const cartClose   = document.getElementById('pb-cart-close');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    cartOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    refreshCartDrawer();
    document.dispatchEvent(new Event('pb-cart-opened'));
  }

  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    cartOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeCart();
  });

  /* Intercept all cart icon clicks → open drawer */
  document.querySelectorAll('.pb-cart-btn, [href="/cart"]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      if (window.location.pathname === '/cart') return;
      e.preventDefault();
      openCart();
    });
  });

  /* Refresh cart drawer via AJAX + fetch compare_at_price depuis /products/{handle}.js */
  function refreshCartDrawer() {
    window.pbRefreshCart = refreshCartDrawer;
    fetch('/cart.js')
      .then(r => r.json())
      .then(function(cart) {
        updateCartCount(cart.item_count);
        var promises = cart.items.map(function(item) {
          return fetch('/products/' + item.handle + '.js')
            .then(r => r.json())
            .then(function(product) {
              var variant = product.variants.find(function(v) { return v.id === item.variant_id; });
              if (variant) item.compare_at_price = variant.compare_at_price;
              return item;
            })
            .catch(function() { return item; });
        });
        Promise.all(promises).then(function() {
          renderCartItems(cart);
        });
      })
      .catch(console.error);
  }

  function updateCartCount(count) {
    document.querySelectorAll('.pb-cart-count').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
    const drawerCount = document.getElementById('pb-cart-count-drawer');
    if (drawerCount) drawerCount.textContent = count;
  }

  function updateSubtotal(totalPrice) {
    const sub = document.getElementById('pb-cart-subtotal');
    if (sub) sub.textContent = formatMoney(totalPrice);
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* Real per-line discount actually applied to the cart (e.g. Buy 2 / Buy 3 tier codes),
     independent from the item's own compare_at_price markup. This is what makes tier
     discounts (VEST2, MAT2, etc.) show up correctly in the Savings row and per-item badge. */
  function lineDiscount(item) {
    var orig = item.original_line_price || (item.price * item.quantity);
    var fin  = item.final_line_price != null ? item.final_line_price : item.line_price;
    var d = orig - fin;
    return d > 0 ? d : 0;
  }

  function updateDrawerSavings(cart) {
    var row      = document.getElementById('pb-cart-savings-row');
    var labelEl  = document.querySelector('#pb-cart-savings-row .pb-cart-savings-label');
    var amountEl = document.querySelector('#pb-cart-savings-row .pb-cart-savings-amount');
    if (!row) return;
    var totalCompare = 0;
    var totalActual  = 0;
    var totalCartDiscount = 0;
    cart.items.forEach(function(item) {
      var compareAt = (item.compare_at_price && item.compare_at_price > item.price)
        ? item.compare_at_price : item.price;
      totalCompare += compareAt * item.quantity;
      totalActual  += item.price * item.quantity;
      totalCartDiscount += lineDiscount(item);
    });
    var markupSavings = totalCompare - totalActual;
    var savings = markupSavings + totalCartDiscount;
    if (savings > 0) {
      var base = totalCompare + totalCartDiscount;
      var pct = base > 0 ? Math.round((savings / base) * 100) : 0;
      row.style.display = 'flex';
      if (labelEl)  labelEl.textContent  = 'Savings (' + pct + '% off)';
      if (amountEl) amountEl.textContent = '-' + formatMoney(savings);
    } else {
      row.style.display = 'none';
    }
  }

  function renderCartItems(cart) {
    var body = document.getElementById('pb-cart-body');
    if (!body) return;
    updateSubtotal(cart.total_price);
    updateDrawerSavings(cart);
    if (cart.item_count === 0) {
      body.innerHTML = '<div class="pb-cart-empty"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" style="width:48px;height:48px;color:var(--pb-gray-text);margin-bottom:16px"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg><p>Your cart is empty.</p><a href="/collections/all" class="pb-btn pb-btn-primary" style="margin-top:16px">Shop now</a></div>';
      return;
    }
    var html = '<div id="pb-cart-items">';
    cart.items.forEach(function(item) {
      var img = item.image ? item.image.replace(/\.(jpg|jpeg|png|gif|webp)/, '_100x100.$1') : '';
      var variantLine = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<div class="pb-cart-item-variant">' + item.variant_title + '</div>' : '';
      var badgeHtml = '', compareHtml = '', savingsHtml = '';
      var markupSave = (item.compare_at_price && item.compare_at_price > item.price)
        ? (item.compare_at_price - item.price) * item.quantity : 0;
      var cartDiscountSave = lineDiscount(item);
      var itemTotalSave = markupSave + cartDiscountSave;
      if (item.compare_at_price && item.compare_at_price > item.price) {
        var pct = Math.round((item.compare_at_price - item.price) / item.compare_at_price * 100);
        badgeHtml   = '<span class="pb-cart-item-badge">-' + pct + '%</span>';
        compareHtml = '<span class="pb-cart-item-compare">' + formatMoney(item.compare_at_price) + '</span>';
      }
      if (itemTotalSave > 0) {
        savingsHtml = '<div class="pb-cart-item-savings">🌿 You save ' + formatMoney(itemTotalSave) + '</div>';
      }
      html += '<div class="pb-cart-item" data-key="' + item.key + '">'
        + '<div class="pb-cart-item-img-wrap">'
        + (img ? '<img src="' + img + '" alt="' + item.title + '" class="pb-cart-item-img">' : '')
        + badgeHtml + '</div>'
        + '<div class="pb-cart-item-info">'
        + '<div class="pb-cart-item-title">' + item.product_title + '</div>'
        + variantLine
        + '<div class="pb-cart-item-price-row">' + compareHtml
        + '<span class="pb-cart-item-price">' + formatMoney(item.final_line_price / item.quantity) + '</span></div>'
        + savingsHtml
        + '<div class="pb-cart-item-qty">'
        + '<button class="pb-cart-qty-btn" data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '">−</button>'
        + '<span>' + item.quantity + '</span>'
        + '<button class="pb-cart-qty-btn" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '">+</button>'
        + '</div></div>'
        + '<button class="pb-cart-remove" data-key="' + item.key + '" aria-label="Remove">🗑</button>'
        + '</div>';
    });
    html += '</div>';
    body.innerHTML = html;
    bindCartEvents();
  }

  function bindCartEvents() {
    document.querySelectorAll('.pb-cart-qty-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        const key = btn.dataset.key;
        const qty = parseInt(btn.dataset.qty, 10);
        updateCartItem(key, Math.max(0, qty));
      });
    });
    document.querySelectorAll('.pb-cart-remove').forEach(function(btn) {
      btn.addEventListener('click', function() {
        updateCartItem(btn.dataset.key, 0);
      });
    });
  }

  function updateCartItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(r => r.json())
    .then(function() {
      refreshCartDrawer();
    })
    .catch(console.error);
  }

  /* ── Add to Cart (AJAX) ── */
  document.querySelectorAll('form[action="/cart/add"]').forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      const formData = new FormData(form);
      const btn = form.querySelector('[name="add"]');
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      })
      .then(r => r.json())
      .then(function() {
        if (btn) { btn.disabled = false; btn.innerHTML = '✓ Added to cart'; }
        setTimeout(function() {
          if (btn) btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:20px;height:20px"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg> Add to cart';
        }, 2000);
        openCart();
      })
      .catch(function(err) {
        console.error(err);
        if (btn) { btn.disabled = false; btn.textContent = 'Add to cart'; }
      });
    });
  });

  /* ── Newsletter form ── */
  document.querySelectorAll('.pb-nl-form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const input = form.querySelector('.pb-nl-input');
      const btn = form.querySelector('.pb-nl-btn');
      if (!input || !input.value) return;
      if (btn) { btn.textContent = '✓ Subscribed!'; btn.style.background = '#16A34A'; }
      input.value = '';
      setTimeout(function () {
        if (btn) { btn.textContent = 'Subscribe'; btn.style.background = ''; }
      }, 3000);
    });
  });

  /* ── Cart page qty/remove ── */
  document.querySelectorAll('.pb-cart-page-remove').forEach(function(btn) {
    btn.addEventListener('click', function() {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: btn.dataset.key, quantity: 0 })
      }).then(() => window.location.reload());
    });
  });

  document.querySelectorAll('.pb-cart-page .pb-qty-val').forEach(function(input) {
    input.addEventListener('change', function() {
      const qty = parseInt(input.value, 10);
      if (isNaN(qty) || qty < 0) return;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: input.dataset.key, quantity: qty })
      }).then(() => window.location.reload());
    });
  });

  /* Init cart count on load */
  fetch('/cart.js').then(r => r.json()).then(cart => updateCartCount(cart.item_count)).catch(() => {});
  bindCartEvents();

});

/* ══════════════════════════════════════════
   COUNTDOWN TIMER (Product Page)
══════════════════════════════════════════ */
(function() {
  const el = document.getElementById('pb-countdown');
  if (!el) return;
  const hEl = document.getElementById('pb-cd-h');
  const mEl = document.getElementById('pb-cd-m');
  const sEl = document.getElementById('pb-cd-s');
  const initH = parseInt(el.dataset.hours || 2, 10);
  const initM = parseInt(el.dataset.minutes || 0, 10);
  let total = initH * 3600 + initM * 60;
  function pad(n){ return String(n).padStart(2,'0'); }
  function tick() {
    if (total <= 0) { total = initH * 3600 + initM * 60; return; }
    total--;
    const h = Math.floor(total / 3600);
    const m = Math.floor((total % 3600) / 60);
    const s = total % 60;
    if (hEl) hEl.textContent = pad(h);
    if (mEl) mEl.textContent = pad(m);
    if (sEl) sEl.textContent = pad(s);
  }
  tick();
  setInterval(tick, 1000);
})();

/* ══════════════════════════════════════════
   CART RESERVATION TIMER (Cart Drawer)
══════════════════════════════════════════ */
(function() {
  const timerEl = document.getElementById('pb-cart-timer');
  if (!timerEl) return;
  let seconds = 10 * 60;
  function pad(n){ return String(n).padStart(2,'0'); }
  function tick() {
    if (seconds <= 0) { seconds = 10 * 60; }
    seconds--;
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    timerEl.textContent = pad(m) + ':' + pad(s);
  }
  tick();
  setInterval(tick, 1000);

  document.addEventListener('pb-cart-opened', function() {
    const discountBar = document.getElementById('pb-cart-discount-bar');
    const progressWrap = document.getElementById('pb-cart-progress-wrap');
    const progressBar = document.getElementById('pb-cart-progress-bar');
    if (discountBar) discountBar.style.display = 'block';
    if (progressWrap) progressWrap.style.display = 'block';
    setTimeout(function() {
      if (progressBar) progressBar.style.width = '95%';
    }, 300);
  });
})();

/* Offer card selection */
document.querySelectorAll('.pb-offer-card').forEach(function(card) {
  card.addEventListener('click', function() {
    document.querySelectorAll('.pb-offer-card').forEach(c => c.classList.remove('pb-offer-card--selected'));
    card.classList.add('pb-offer-card--selected');
    const radio = card.querySelector('input[type="radio"]');
    if (radio) radio.checked = true;
  });
});